import { AfterViewInit, ChangeDetectorRef, Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { MensajeInicialComponent } from '../mensaje-inicial/mensaje-inicial.component';
import { AlertIcon, AlertService, LocalService, SessionStorageService } from 'lib-base';
import { MensajeFirmaElectronicaInvalidaComponent } from '../mensaje-firma-electronica-invalida/mensaje-firma-electronica-invalida.component';
import { CommonModule } from '@angular/common';
import { TramRegistroSolicitudService } from '../../../services/tramiteRegistroSolicitud.service';
import { firstValueFrom, forkJoin, Subscription } from 'rxjs';
import { Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-mensajes-emergentes',
  standalone: true,
  imports: [CommonModule, MensajeInicialComponent, MensajeFirmaElectronicaInvalidaComponent],
  template:`  
    <app-mensaje-inicial/>
    <app-mensaje-firma-electronica-invalida [visible]="openMensajeFirmaElectronicaInvalida" *ngIf="openMensajeFirmaElectronicaInvalida"/>
  `,
})
export class MensajesEmergentesComponent implements OnInit, AfterViewInit, OnDestroy {
  private _hideDialog !: Subscription;
  private _trans: any = {};

  openMensajeFirmaElectronicaInvalida: boolean = false;

  @ViewChild(MensajeInicialComponent) mensajeInicial!: MensajeInicialComponent;

  constructor(private _ss: SessionStorageService, private _ls: LocalService, private cdr: ChangeDetectorRef, private _translate: TranslateService,
    private readonly _trss: TramRegistroSolicitudService,  private readonly _als: AlertService, private readonly _router: Router
  ) {
    
  }

  ngOnInit() {
    this.translate();
  }

  ngAfterViewInit(): void {
    if(!this._ls.isLoggedIn){
      this.showMensajeInicial();
      return;
    }

    if(this._ls.isFirmaElectronicaExpired || this._ls.isFirmaElectronicaProximaVencimiento){
      if(this._ss.showMensajeFirmaElectronicaInvalida){
        this.openMensajeFirmaElectronicaInvalida = true;
        this._ss.showMensajeFirmaElectronicaInvalida = false;
      }
    }else{
      if (!this._ls.checkedTramitesPendientes) {
        this._ls.checkedTramitesPendientes = true;
        this.getSolicitudPendienteReciente();
      }else{
        this.showMensajeInicial();
      }  
    }
  }

  ngOnDestroy(): void {
    if (this._hideDialog) {
      this._hideDialog.unsubscribe();
    }
  }
  
  private async translate(): Promise<void> {
    this._trans = await firstValueFrom(forkJoin({
      tramitePendiente: this._translate.get('msg.tramitePendiente'),
      tareaPendiente: this._translate.get('msg.tareaPendiente'),
      continuar: this._translate.get('common.continuar')
    }));
  }

  private showMensajeInicial(){
    if(this._ss.showMensajeInicial){
      this.mensajeInicial.show();
      this._ss.showMensajeInicial = false;
      this.cdr.detectChanges();
    }
  }

  private getSolicitudPendienteReciente() {
    this._trss.getSolicitudPendienteReciente().subscribe({
      next: (id: number) => {
        if (!id) return;
        this._hideDialog = this._als.show({
          icon: AlertIcon.INFO,
          title: this._trans.tramitePendiente,
          text: this._trans.tareaPendiente,
          showAccept: true,
          textAccept: this._trans.continuar,
          showCancel: true,
        }).subscribe(key => {
          if (this._hideDialog) {
            this._hideDialog.unsubscribe();
          }
          if (key.cancel) return;
          this._router.navigate(['/tramites/estado-tramite'], { queryParams: { tabIndex: 1, solicitudId: id } });
        });
      }
    });
  }
}
